import { compose } from 'redux';

export default compose;
